import { render } from "./ProductPartsNamesBundle.vue?vue&type=template&id=5ae3c5f8"
import script from "./ProductPartsNamesBundle.vue?vue&type=script&lang=js"
export * from "./ProductPartsNamesBundle.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mihne\\Desktop\\matrixWork\\individual\\datacenter\\printqMatrix\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__